import { Module } from '@nestjs/common';
import { RejectionsController } from './rejections.controller';
import { RejectionsService } from './rejections.service';
import { TypeOrmModule } from '@nestjs/typeorm';
import { Rejections } from './rejections.entity';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ProductionInventoryService, QaQcOperationsService, QcDefectService, VariantOperationsService, WorkstationService } from '@gtpl/shared-services/production';
import { ProductionLogService } from '../operations-track/production-log.service';
import { ProductionLogRepository } from '../operations-track/repositories/production-log.repository';
import { ProductionInventoryRepository } from '../operations-track/repositories/production-inventory.repository';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { ProductionLogAdapter } from '../operations-track/dto/production-log.adapter';
import { RejectionsRepository } from './rejection.repository';
import { UnitcodeService } from '@gtpl/shared-services/masters';

@Module({
  imports: [
    TypeOrmModule.forFeature([RejectionsRepository,ProductionLogRepository, ProductionInventoryRepository]),
  ],
  controllers: [RejectionsController],
  providers: [RejectionsService,ApplicationExceptionHandler,ProductionInventoryService,ProductionLogService,WorkstationService,SaleOrderService,VariantOperationsService,ProductionLogAdapter,QaQcOperationsService,UnitcodeService,QcDefectService]
})
export class RejectionsModule {}

